import { ClientPathSchema } from "@/features/dashboard/client/clientSchema";
import { CorporateInfoEditPage } from "@/features/dashboard/client/detail/components/corporate-info-edit/CorporateInfoEditPage";
import { ProcedureTypeEnum } from "@/features/dashboard/client/clientEnum";
import { usePageTitle } from "@/hooks/usePageTitle";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const CorporateInfoEditSearchSchema = z.object({
  role: z
    .enum([ProcedureTypeEnum.RepresentativeSelf, ProcedureTypeEnum.ContactPerson])
    .optional(),
});

export const Route = createFileRoute("/_dashboard/clients/$clientId/corporate-info/edit")({
  component: RouteComponent,
  parseParams: ClientPathSchema.parse,
  validateSearch: CorporateInfoEditSearchSchema,
});

function RouteComponent() {
  usePageTitle("代表者/担当者情報編集");
  return <CorporateInfoEditPage />;
}
